//#region src/redux/posts/thunk-types.ts
var thunkTypes = { GET_POSTS: `posts/getPosts` };
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map